import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { User } from '@features/authenticate/types/user';
import { InitialsAvatarComponent } from '../initials-avatar/initials-avatar.component';

@Component({
  selector: 'app-user-avatar',
  standalone: true,
  imports: [ InitialsAvatarComponent ],
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserAvatarComponent {
  public user: InputSignal<User> = input.required();
}
